import { BdcShipmentRow } from "../../../types/bdc.type";

export type BulkAction = "confirm_do" | "issue";

export const BULK_LABEL: Record<BulkAction, string> = {
  confirm_do: "ยืนยัน DO",
  issue: "ออก INV",
};

/** The status a row must be in for the action (plan §2): ยืนยัน DO from ร่าง, ออก INV from ยืนยัน DO. */
const FROM_STATUS: Record<BulkAction, string> = {
  confirm_do: "draft",
  issue: "do_confirmed",
};

/** The ticked rows the action applies to, and the ticked ones it skips (wrong status). */
export const bulkTargets = (
  rows: BdcShipmentRow[],
  selected: ReadonlySet<string>,
  action: BulkAction,
): { targets: BdcShipmentRow[]; skipped: BdcShipmentRow[] } => {
  const ticked = rows.filter((row) => selected.has(row.shipment_uuid));
  return {
    targets: ticked.filter((row) => row.status === FROM_STATUS[action]),
    skipped: ticked.filter((row) => row.status !== FROM_STATUS[action]),
  };
};

export interface BulkResult {
  po_number: string;
  ok: boolean;
  message: string;
}

/**
 * Run the action one PO at a time (each INV takes the next number under a row lock, so order
 * matters and parallel calls gain nothing). A failure is recorded and the rest still run —
 * except a running-number problem, which would fail every remaining PO the same way.
 */
export const runBulk = async (
  targets: BdcShipmentRow[],
  call: (poNumber: string) => Promise<string>,
  readError: (error: unknown) => { message: string; stopAll: boolean },
): Promise<BulkResult[]> => {
  const results: BulkResult[] = [];
  for (const row of targets) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const message = await call(row.po_number);
      results.push({ po_number: row.po_number, ok: true, message });
    } catch (error) {
      const { message, stopAll } = readError(error);
      results.push({ po_number: row.po_number, ok: false, message });
      if (stopAll) {
        targets
          .slice(targets.indexOf(row) + 1)
          .forEach((rest) => results.push({ po_number: rest.po_number, ok: false, message: "ไม่ได้ทำ — หยุดเพราะเลข INV" }));
        break;
      }
    }
  }
  return results;
};
